export default "__VITE_ASSET__BrAg01pN__"